import WhatsAppLink from './WhatsAppLink';

export default WhatsAppLink;
